import {CSSProperties, FC} from 'react';


export interface IIconInteriorAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconInteriorAvito: FC<IIconInteriorAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
                <path d="M4.42 13.445c-2.02 1.16-3.25 2.329-3.913 3.713-.562 1.175-.655 2.292-.288 3.469.48 1.541 1.887 3.066 3.932 4.263 7.08 4.146 20.62 4.146 27.7 0 1.489-.872 2.843-2.114 3.447-3.164 1.163-2.02.873-4.183-.813-6.062-.727-.81-1.687-1.54-2.985-2.266-.73-.41-1.007-.439-1.332-.14-.171.159-.22.262-.22.474 0 .403.153.578.838.957 1.96 1.086 3.223 2.356 3.643 3.66.094.292.117.545.094 1.049-.025.563-.064.739-.257 1.154-1.401 3.005-6.736 5.324-13.493 5.864-1.16.093-4.286.093-5.512 0-7.068-.533-12.679-3.119-13.69-6.308-.093-.292-.116-.549-.094-1.03.027-.577.06-.702.333-1.272.529-1.1 1.7-2.172 3.405-3.117.341-.189.67-.424.733-.522.22-.346.098-.872-.238-1.03-.325-.153-.605-.086-1.29.308Z" />
                <path stroke="#000" strokeWidth=".6" d="M25.865 2.043c-.557.131-1.105.547-1.364 1.036-.114.215-.681 2.066-1.687 5.508-.834 2.85-1.534 5.202-1.556 5.226-.022.023-2.17-.223-4.774-.548-5.115-.637-5.339-.653-5.932-.423a2.566 2.566 0 0 0-1.401 1.402c-.145.375-.195 1.047-.108 1.453.077.363 2.623 5.292 2.855 5.527l.15.154h5.795c5.436 0 5.802-.006 5.913-.098.096-.078.624-1.893 2.681-9.21C27.847 7.058 29 2.9 29 2.83c0-.28-.186-.365-1.337-.614-1.087-.235-1.405-.266-1.798-.173Zm1.408.99c.571.13.693.174.68.25-.01.052-1.094 3.93-2.41 8.62-1.318 4.69-2.395 8.54-2.395 8.555 0 .016-2.409.022-5.353.014l-5.354-.014-.95-1.811a210.2 210.2 0 0 1-1.284-2.48c-.333-.669-.334-.67-.31-1.087.029-.51.16-.79.517-1.104.285-.252.656-.4.998-.402.125 0 2.474.277 5.22.616 5.29.652 5.229.648 5.345.375.03-.07.758-2.546 1.619-5.505 1.083-3.725 1.61-5.454 1.715-5.626.195-.319.63-.56 1.006-.558.142 0 .572.072.956.158Z" />
            </g>
            <defs><clipPath id="a"><path d="M0 0H36V36H0z" /></clipPath></defs>
        </svg>
    );
};
